module.exports = __webpack_public_path__ + "static/media/dk.b4ba001c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dk.svg
// module id = 100
// module chunks = 0